// Generated by Melange

import * as Buhta_cabinet__Filter from "../Filter.js";
import * as Buhta_cabinet__Input from "../../html/Input.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_struct from "../../../../../../proto/third_party/google_wkt/gen/google_protobuf_struct.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(dispatch) {
  return function (page) {
    return function (setPage) {
      return function (searchLengthOpt) {
        const searchLength = searchLengthOpt !== undefined ? searchLengthOpt : 2;
        return function (expandOpt) {
          const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
          return function (showFilterOpt) {
            const showFilter = showFilterOpt !== undefined ? showFilterOpt : false;
            return function (ignoreFirstTimeOpt) {
              const ignoreFirstTime = ignoreFirstTimeOpt !== undefined ? ignoreFirstTimeOpt : false;
              return function (classNameOpt) {
                const className = classNameOpt !== undefined ? classNameOpt : "";
                const match = React.useState(function () {
                      return "";
                    });
                const setSearchText = match[1];
                const searchText = match[0];
                const match$1 = React.useState(function () {
                      return /* [] */0;
                    });
                const setStateFromFilter = match$1[1];
                const stateFromFilter = match$1[0];
                const match$2 = React.useState(function () {
                      return "";
                    });
                const setPeriodFromFilter = match$2[1];
                const periodFromFilter = match$2[0];
                const firstTime = React.useRef(ignoreFirstTime ? true : false);
                React.useEffect((function () {
                        const filters = Stdlib__List.length(stateFromFilter) > 0 ? ({
                              hd: {
                                name: "state",
                                value: Curry._2(Google_wkt__Google_protobuf_struct.Google.Protobuf.Value.make, {
                                      NAME: "List_value",
                                      VAL: Curry._2(Google_wkt__Google_protobuf_struct.Google.Protobuf.ListValue.make, Stdlib__List.map((function (el) {
                                                  return Curry._2(Google_wkt__Google_protobuf_struct.Google.Protobuf.Value.make, {
                                                              NAME: "String_value",
                                                              VAL: el
                                                            }, undefined);
                                                }), stateFromFilter), undefined)
                                    }, undefined)
                              },
                              tl: /* [] */0
                            }) : /* [] */0;
                        const filters$1 = periodFromFilter !== "" ? Stdlib.$at(filters, {
                                hd: {
                                  name: "period",
                                  value: Curry._2(Google_wkt__Google_protobuf_struct.Google.Protobuf.Value.make, {
                                        NAME: "String_value",
                                        VAL: periodFromFilter
                                      }, undefined)
                                },
                                tl: /* [] */0
                              }) : filters;
                        const params_search = searchText === "" ? undefined : Stdlib__String.trim(searchText);
                        const params = {
                          search: params_search,
                          page: page,
                          filters: filters$1,
                          expand: expand
                        };
                        if ((searchText.length > searchLength || searchText.length === 0) && !firstTime.current) {
                          firstTime.current = false;
                          const debounce = setTimeout((function (param) {
                                  Curry._3(dispatch, undefined, params, undefined);
                                }), 200);
                          return (function (param) {
                                    clearTimeout(debounce);
                                  });
                        }
                        firstTime.current = false;
                      }), [
                      searchText,
                      page,
                      stateFromFilter,
                      periodFromFilter
                    ]);
                return JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5 ",
                                    alt: "search",
                                    src: StaticAsset.src("/static/icons/search.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                                    className: Cn.$plus("sm:text-sm h-12", className),
                                    value: searchText,
                                    placeholder: "Поиск...",
                                    onChange: (function (value) {
                                        Curry._1(setPage, (function (param) {
                                                return 1;
                                              }));
                                        Curry._1(setSearchText, (function (param) {
                                                return value;
                                              }));
                                      })
                                  }),
                              showFilter ? JsxRuntime.jsx(Buhta_cabinet__Filter.make, {
                                      sendDataToFilter: (function (data) {
                                          Curry._1(setStateFromFilter, (function (param) {
                                                  return data;
                                                }));
                                        }),
                                      sendPeriodToFilter: (function (period) {
                                          Curry._1(setPeriodFromFilter, (function (param) {
                                                  return period;
                                                }));
                                        }),
                                      className: "mr-4 lg:mr-6"
                                    }) : null
                            ],
                            className: Cn.fromList({
                                  hd: "flex items-center w-auto justify-between lg:pl-6 pl-4 m-4 lg:m-0 lg:w-full gap-1 rounded shadow-search lg:shadow-none lg:rounded-none",
                                  tl: {
                                    hd: className,
                                    tl: /* [] */0
                                  }
                                })
                          });
              };
            };
          };
        };
      };
    };
  };
}

function Search(Props) {
  return Curry._6(make(Props.dispatch)(Props.page), Props.setPage, Props.searchLength, Props.expand, Props.showFilter, Props.ignoreFirstTime, Props.className);
}

const make$1 = Search;

export {
  make$1 as make,
}
/* Buhta_cabinet__Filter Not a pure module */
